import { i18nMark } from 'lingui-react';

const messages = {
  copyrightText: i18nMark('Copyright © {year} Decisiv, Inc.'),
  termsOfUse: i18nMark('Terms of Use'),
  privacyPolicy: i18nMark('Privacy Policy'),
  version: i18nMark('{app} version {version}'),
  versionWithGit: i18nMark('{app} version {version} (GIT SHA {gitVersion})'),
};

export default messages;



// WEBPACK FOOTER //
// ./components/GlobalFooter/InfoWrapper/messages.js